function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.000001 24",
    height: 24,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 1.03575
    },
    ry: 2.3649671,
    rx: 2.342834,
    cy: 3.3649671,
    cx: 7.5233407,
    id: "Oval",
    fillRule: "nonzero",
    fill: "#a3958a"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.03575
    },
    id: "Path",
    d: "m 7.2587105,5.5721131 c 0.7608339,0.0072 1.4965221,0.3061739 1.9022303,0.8822894 1.1314362,1.521088 2.4746382,2.8152561 4.1131092,3.7726675 0.349563,0.204521 0.559262,0.500987 0.65844,0.822167 0.111595,0.361398 0.08004,0.756837 -0.05928,1.089557 -0.146672,0.350296 -0.410377,0.625864 -0.735789,0.743231 -0.28884,0.104178 -0.633676,0.09372 -1.006689,-0.124852 -1.00685,-0.588908 -1.930521,-1.257831 -2.7787632,-2.012 0.0067,1.033388 0.051004,2.066368 0.143099,3.101959 0.012258,0.137625 0.099488,0.559667 0.1360718,0.668631 0.6893134,2.080786 1.3799524,4.160903 2.0715974,6.242059 0.138437,0.416721 0.08972,0.785351 -0.06395,1.084281 -0.173754,0.338019 -0.489645,0.589736 -0.851218,0.712042 -0.361638,0.122328 -0.764085,0.113541 -1.1045324,-0.05054 C 9.3818939,22.358463 9.1229846,22.093839 8.984998,21.677374 8.4259759,19.996282 7.8674706,18.314407 7.3092133,16.633339 6.3866645,18.321229 5.8249749,19.976245 5.2443035,21.970126 5.1595729,22.261268 4.9916315,22.504879 4.774344,22.682458 4.5510433,22.864951 4.2754452,22.977487 3.9842357,23 3.33855,22.870941 2.9637725,22.630319 2.7374895,22.347857 2.4562899,21.996842 2.3873349,21.572355 2.5082453,21.158166 3.2263431,18.690598 3.9346117,16.673937 5.0404221,14.542319 5.1541585,14.32286 5.2101492,14.081182 5.2025291,13.833934 5.1810156,13.135121 5.1432076,11.77717 5.1346891,10.678736 4.9132633,10.969385 4.7056417,11.260144 4.5126486,11.550253 4.2482878,11.949245 3.8137468,12.164941 3.371363,12.164941 c -0.2631844,0 -0.5281437,-0.07587 -0.7630282,-0.234805 -0.3148727,-0.212906 -0.5142792,-0.5345 -0.5822501,-0.88241 -0.067958,-0.347845 -0.0045,-0.722009 0.20654,-1.040271 C 3.0409025,8.7910265 4.0590383,7.574952 5.2589063,6.3951386 5.7121319,5.8576613 6.4882373,5.5648219 7.2587105,5.5721131 Z",
    fillRule: "nonzero",
    fill: "#a3958a"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.1f17576e.svg";
export { ForwardRef as ReactComponent };